import React from 'react';
import InfoTooltip from './InfoTooltip';

export interface DmfStatusHeaderTooltipProps {
  /** Forwarded to InfoTooltip — override for a call site nested above InfoTooltip's own default. */
  zIndex?: number;
}

/**
 * Field-level tooltip for the USDMF "Status" label — outlines what each
 * value represents (2026-09-23 follow-up feedback). `dmf.DMF_Products.status`
 * is 'A'/'I' (docs/features/fda-usdmf-integration.md line 70) — an internal
 * import-pipeline convention, not an external regulatory notation, so
 * unlike TeCodeHeaderTooltip/ApplTypeHeaderTooltip/DeaScheduleHeaderTooltip
 * this has no external source link.
 */
const DmfStatusHeaderTooltip: React.FC<DmfStatusHeaderTooltipProps> = ({
  zIndex,
}) => (
  <InfoTooltip
    ariaLabel="About Status"
    zIndex={zIndex}
    text={
      <span>
        A = Active filing
        <br />I = Inactive filing
      </span>
    }
  />
);

export default DmfStatusHeaderTooltip;
